<script>
	import legal from '$lib/icons/legal-svgrepo-com.svg';
</script>

<div class="content-div">
	<div class="flex">
		<h1 class="content-heading">Legal Notice</h1>
		<!--<img src={legal} alt="..." width="25px" />-->
	</div>
	<div />
	<section>
		<div>
			<h3 class="h3">Project Leader:</h3>
			<p>
				Francios Engelbrecht (Wits GCI) (project)<br />
				Sophie Biskop (Uni Jena) (German side)
			</p>
			<h3 class="h3">Postal Address</h3>
			<p>
				Friedrich Schiller University Jena<br />
				Institute of Geography<br />
				Loebdergraben 32<br />
				07743 Jena<br />
			</p>
			<h3 class="h3">Disclaimer</h3>
			<h4 class="h4">Content</h4>
			<p>
				The author reserves the right not to be responsible for the topicality, correctness,
				completeness or quality of the information provided. Liability claims regarding damage
				caused by the use of any information provided, including any kind of information which is
				incomplete or incorrect, will therefore be rejected.
			</p>
			<h4 class="h4">Links</h4>
			<p>
				The author is not responsible for any contents linked or referred to from his pages - unless
				he has full knowledge of illegal contents and would be able to prevent the visitors of his
				site from viewing those pages. If any damage occurs by the use of information presented
				there, only the author of the respective pages might be liable, not the one who has linked
				to these pages. Furthermore the author is not liable for any postings or messages published
				by users of discussion boards, guestbooks or mailinglists provided on his page.
			</p>
			<h4 class="h4">Legal validity of this disclaimer</h4>
			<p>
				This disclaimer is to be regarded as part of the internet publication which you were
				referred from. If sections or individual terms of this statement are not legal or correct,
				the content or validity of the other parts remain uninfluenced by this fact.
			</p>
		</div>
	</section>
</div>
